enum LangType {
  zh = 'CN',
  en = 'EN',
  ph = 'PH'
}
export default LangType
